/* Tykables Product Reviews - storefront component.
 * <tyk-review-form> renders ONLY for logged-in customers; asks the App-Proxy backend
 * GET /apps/pwa/reviews/eligible then renders the form; POST /apps/pwa/reviews.
 * Identity comes from logged_in_customer_id server-side (never the DOM). */
(function () {
  'use strict';
  if (window.customElements && customElements.get('tyk-review-form')) return;
  var cfg = window.tykReviewsConfig || {};
  var PROXY_BASE = cfg.proxyBase || '/apps/pwa/reviews';

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'text') node.textContent = attrs[k];
        else if (k === 'html') node.innerHTML = attrs[k];
        else node.setAttribute(k, attrs[k]);
      });
    }
    (children || []).forEach(function (c) { node.appendChild(c); });
    return node;
  }

  var INELIGIBLE_COPY = {
    not_purchased: 'Reviews are limited to verified purchasers. Once you have ordered this product and it has been delivered, you can review it here.',
    not_delivered: 'Thanks for your order! You will be able to review this product once your delivery is confirmed.',
    already_reviewed: 'You have already reviewed this product - thank you!'
  };

  var FIT_OPTIONS = [
    { value: 'runs_small', label: 'Runs small' },
    { value: 'true_to_size', label: 'True to size' },
    { value: 'runs_large', label: 'Runs large' }
  ];

  function defineReviewForm() {
    function C() { return Reflect.construct(HTMLElement, [], C); }
    C.prototype = Object.create(HTMLElement.prototype);
    C.prototype.constructor = C;

    C.prototype.connectedCallback = function () {
      if (!cfg.customerId) return;
      this.productId = this.dataset.productId;
      if (!this.productId) return;
      this.checkEligibility();
    };

    C.prototype.checkEligibility = function () {
      var self = this;
      fetch(PROXY_BASE + '/eligible?product_id=' + encodeURIComponent(this.productId), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) {
          if (data && data.eligible) self.renderForm();
          else self.renderIneligible(data && data.reason);
        })
        .catch(function () { self.textContent = ''; });
    };

    C.prototype.renderIneligible = function (reason) {
      var copy = INELIGIBLE_COPY[reason];
      this.textContent = '';
      if (!copy) return;
      this.appendChild(el('p', { class: 'tyk-reviews__ineligible', text: copy }));
    };

    C.prototype.renderForm = function () {
      var self = this;
      this.textContent = '';
      var form = el('form', { class: 'tyk-reviews__form', novalidate: 'novalidate' });
      form.appendChild(el('h3', { class: 'tyk-reviews__form-heading', text: 'Write a review' }));

      var ratingWrap = el('fieldset', { class: 'tyk-reviews__rating-input' });
      ratingWrap.appendChild(el('legend', { text: 'Your rating' }));
      var starRow = el('div', { class: 'tyk-reviews__rating-stars', role: 'radiogroup' });
      for (var i = 1; i <= 5; i++) {
        var id = 'tyk-review-star-' + i;
        var input = el('input', { type: 'radio', name: 'rating', value: String(i), id: id, required: 'required' });
        var label = el('label', { for: id, 'aria-label': i + ' star' + (i > 1 ? 's' : '') });
        label.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 1.5l2.1 4.3 4.7.7-3.4 3.3.8 4.7L8 12.3 3.8 14.5l.8-4.7L1.2 6.5l4.7-.7z"/></svg>';
        starRow.appendChild(input); starRow.appendChild(label);
      }
      ratingWrap.appendChild(starRow); form.appendChild(ratingWrap);

      var titleField = el('div', { class: 'field' });
      titleField.appendChild(el('input', { type: 'text', name: 'title', id: 'tyk-review-title', class: 'field__input', maxlength: '100', placeholder: 'Title', 'aria-label': 'Review title' }));
      form.appendChild(titleField);

      var bodyField = el('div', { class: 'field' });
      bodyField.appendChild(el('textarea', { name: 'body', id: 'tyk-review-body', class: 'field__input tyk-reviews__textarea', rows: '4', maxlength: '2000', required: 'required', placeholder: 'What did you think?', 'aria-label': 'Review' }));
      form.appendChild(bodyField);

      var fitWrap = el('fieldset', { class: 'tyk-reviews__fit-input' });
      fitWrap.appendChild(el('legend', { text: 'How does it fit?' }));
      FIT_OPTIONS.forEach(function (opt) {
        var id = 'tyk-review-fit-' + opt.value;
        var lab = el('label', { class: 'tyk-reviews__fit-option', for: id });
        lab.appendChild(el('input', { type: 'radio', name: 'fit', value: opt.value, id: id }));
        lab.appendChild(el('span', { text: opt.label }));
        fitWrap.appendChild(lab);
      });
      form.appendChild(fitWrap);

      form.appendChild(el('input', { type: 'text', name: 'website', tabindex: '-1', autocomplete: 'off', 'aria-hidden': 'true', style: 'position:absolute !important;left:-9999px;height:0;width:0;opacity:0' }));

      var errWrap = el('div', { class: 'product-form__error-message-wrapper', role: 'alert', hidden: 'hidden' });
      errWrap.appendChild(el('span', { class: 'product-form__error-message' }));
      form.appendChild(errWrap);

      var btn = el('button', { type: 'submit', class: 'button button--primary tyk-reviews__submit' });
      btn.appendChild(el('span', { text: 'Submit review' }));
      var spinner = el('div', { class: 'loading__spinner hidden' });
      spinner.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>';
      btn.appendChild(spinner); form.appendChild(btn);

      form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(form, btn, errWrap); });
      this.appendChild(form);
    };

    C.prototype.submit = function (form, btn, errWrap) {
      var self = this;
      var rating = form.querySelector('input[name="rating"]:checked');
      var body = form.querySelector('textarea[name="body"]').value.trim();
      var title = form.querySelector('input[name="title"]').value.trim();
      var fit = form.querySelector('input[name="fit"]:checked');
      var honey = form.querySelector('input[name="website"]');
      var showError = function (msg) { errWrap.removeAttribute('hidden'); errWrap.querySelector('.product-form__error-message').textContent = msg; };
      errWrap.setAttribute('hidden', 'hidden');
      if (!rating) return showError('Please choose a star rating.');
      if (!body) return showError('Please write a few words about the product.');
      btn.setAttribute('disabled', 'disabled'); btn.classList.add('loading');
      btn.querySelector('.loading__spinner').classList.remove('hidden');
      fetch(PROXY_BASE, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ product_id: this.productId, rating: parseInt(rating.value, 10), title: title, body: body, fit: fit ? fit.value : null, website: honey ? honey.value : '' })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (res.ok && res.json && res.json.ok) {
            self.textContent = '';
            self.appendChild(el('p', { class: 'tyk-reviews__thanks', text: 'Thanks! Your review has been submitted and will appear shortly.' }));
          } else {
            showError((res.json && res.json.error) || 'Something went wrong - please try again.');
          }
        })
        .catch(function () { showError('Network error - please try again.'); })
        .finally(function () {
          btn.removeAttribute('disabled'); btn.classList.remove('loading');
          var sp = btn.querySelector('.loading__spinner'); if (sp) sp.classList.add('hidden');
        });
    };
    return C;
  }

  if (window.customElements) customElements.define('tyk-review-form', defineReviewForm());

  document.addEventListener('click', function (e) {
    var moreBtn = e.target.closest ? e.target.closest('[data-tyk-reviews-more]') : null;
    if (!moreBtn) return;
    var list = document.querySelector('[data-tyk-review-list]');
    if (!list) return;
    var pageSize = parseInt(list.getAttribute('data-page-size'), 10) || 6;
    var hidden = list.querySelectorAll('li[hidden]');
    for (var i = 0; i < Math.min(pageSize, hidden.length); i++) hidden[i].removeAttribute('hidden');
    if (list.querySelectorAll('li[hidden]').length === 0) moreBtn.remove();
  });
})();
